import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import Backend from "i18next-http-backend";
import LanguageDetector from "i18next-browser-languagedetector";

// Import translation files
import enCommon from "../locales/en/common.json";
import enAuth from "../locales/en/auth.json";
import enChat from "../locales/en/chat.json";
import enSettings from "../locales/en/settings.json";
import enErrors from "../locales/en/errors.json";

import arCommon from "../locales/ar/common.json";
import arAuth from "../locales/ar/auth.json";
import arChat from "../locales/ar/chat.json";
import arSettings from "../locales/ar/settings.json";
import arErrors from "../locales/ar/errors.json";

import deCommon from "../locales/de/common.json";
import deAuth from "../locales/de/auth.json";
import deChat from "../locales/de/chat.json";
import deSettings from "../locales/de/settings.json";
import deErrors from "../locales/de/errors.json";

import jaCommon from "../locales/ja/common.json";
import jaAuth from "../locales/ja/auth.json";
import jaChat from "../locales/ja/chat.json";
import jaSettings from "../locales/ja/settings.json";
import jaErrors from "../locales/ja/errors.json";

import trCommon from "../locales/tr/common.json";
import trAuth from "../locales/tr/auth.json";
import trChat from "../locales/tr/chat.json";
import trSettings from "../locales/tr/settings.json";
import trErrors from "../locales/tr/errors.json";

const resources = {
  en: {
    common: enCommon,
    auth: enAuth,
    chat: enChat,
    settings: enSettings,
    errors: enErrors,
    dashboard: require("../locales/en/dashboard.json"),
    features: require("../locales/en/features.json"),
    hero: require("../locales/en/hero.json"),
    cta: require("../locales/en/cta.json"),
    footer: require("../locales/en/footer.json"),
  },
  ar: {
    common: arCommon,
    auth: arAuth,
    chat: arChat,
    settings: arSettings,
    errors: arErrors,
    dashboard: require("../locales/ar/dashboard.json"),
    features: require("../locales/ar/features.json"),
    hero: require("../locales/ar/hero.json"),
    cta: require("../locales/ar/cta.json"),
    footer: require("../locales/ar/footer.json"),
  },
  de: {
    common: deCommon,
    auth: deAuth,
    chat: deChat,
    settings: deSettings,
    errors: deErrors,
    dashboard: require("../locales/de/dashboard.json"),
    features: require("../locales/de/features.json"),
    hero: require("../locales/de/hero.json"),
    cta: require("../locales/de/cta.json"),
    footer: require("../locales/de/footer.json"),
  },
  ja: {
    common: jaCommon,
    auth: jaAuth,
    chat: jaChat,
    settings: jaSettings,
    errors: jaErrors,
    dashboard: require("../locales/ja/dashboard.json"),
    features: require("../locales/ja/features.json"),
    hero: require("../locales/ja/hero.json"),
    cta: require("../locales/ja/cta.json"),
    footer: require("../locales/ja/footer.json"),
  },
  tr: {
    common: trCommon,
    auth: trAuth,
    chat: trChat,
    settings: trSettings,
    errors: trErrors,
    dashboard: require("../locales/tr/dashboard.json"),
    features: require("../locales/tr/features.json"),
    hero: require("../locales/tr/hero.json"),
    cta: require("../locales/tr/cta.json"),
    footer: require("../locales/tr/footer.json"),
  },
};

i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: "en",
    debug: process.env.NODE_ENV === "development",

    interpolation: {
      escapeValue: false,
    },

    detection: {
      order: ["localStorage", "navigator"],
      caches: ["localStorage"],
    },

    ns: [
      "common",
      "auth",
      "chat",
      "settings",
      "errors",
      "dashboard",
      "features",
      "hero",
      "cta",
      "footer",
    ],
    defaultNS: "common",

    react: {
      useSuspense: false,
    },
  });

export default i18n;
